import { render } from "./collapsible-form.vue?vue&type=template&id=5e2efe00&ts=true"
import script from "./collapsible-form.vue?vue&type=script&lang=ts"
export * from "./collapsible-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__